// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3gsug","right":"Footer_right__T0arD","buttons":"Footer_buttons__2ERYz"};